import React from 'react';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { Link as RouterLink, Switch, Route, BrowserRouter, Link } from 'react-router-dom';
import CreateAdmin from '../../../CreateAdmin/CreateAdmin';
import Routes from '../../../../Routes';
import AddIcon from '@material-ui/icons/Add';


const useStyles = makeStyles(() => ({
    root: {},

    title: {
        fontSize: '20px',
    },
    leftIcon: {
      //  marginRight: theme.spacing.unit,
    },

}));

export default function Header(props) {
    const { className, ...rest } = props;
    const classes = useStyles();
 
    return (

        <div {...rest} className={clsx(classes.root, className)} >

            <Grid alignItems="flex-end" container justify="space-between" spacing={3} >
                <Grid item>


                </Grid>
                <Grid item>
                    <Link to="/admin/createadmin">
                        <Button variant="contained"  >
                            <AddIcon className={classes.leftIcon} />
                            Create New Admin
                        </Button>
                    </Link>
                </Grid>
            </Grid>

            {/* <Routes/> */}

            <div style={{ marginBottom: "20px" }}></div>

        </div>



    )
}
